import { useDropzone } from "react-dropzone";
import { useState } from "react";
import styles from "./ModalArchivo.module.css";

function ModalArchivo({
  modo,
  tipo = "",                     // ← PROTECCIÓN
  archivosExistentes = [],       // ← PROTECCIÓN
  onClose,
  onGuardar
}) {
  const [nuevos, setNuevos] = useState([]);
  const [eliminar, setEliminar] = useState([]);
  const [mostrarDropzone, setMostrarDropzone] = useState(false);
  const [archivoAReemplazar, setArchivoAReemplazar] = useState(null);

 const onDrop = (acceptedFiles) => {
    if (archivoAReemplazar) {
      setEliminar(prev => [...prev, archivoAReemplazar.Id_comprobante]);
      setNuevos(prev => [...prev, acceptedFiles[0]]);
      setArchivoAReemplazar(null);
      // ❌ NO CERRAR DROPZONE
      return;
    }

    setNuevos(prev => [...prev, ...acceptedFiles]);
    // ❌ NO CERRAR DROPZONE
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: !archivoAReemplazar,
    disabled: !mostrarDropzone
  });

  const handleGuardar = () => {
    onGuardar({ tipo, nuevos, eliminar });
  };
  
  return (
    <div className={styles["modal-overlay"]}>
      <div className={styles["modal-card"]}>

        <h3>Comprobantes: {(tipo || "").toUpperCase()}</h3>

        {/* ============================
            RECUADRO DE ARCHIVOS EXISTENTES
        ============================ */}
        <div className={styles["recuadro"]}>
          {(archivosExistentes || []).length === 0 ? (
            <p className={styles["sin-archivos"]}>Sin archivos</p>
          ) : (
            (archivosExistentes || []).map(a => {
              const nombreCompleto =
                a.name || // File
                (a.nombre && a.extension ? `${a.nombre}.${a.extension}` : null) ||
                a.Nombre_archivo ||
                "";

              return (
                <div key={a.Id_comprobante || nombreCompleto} className={styles["file-item"]}>
                  <a
                    href={a.url_firmada || a.url}
                    target="_blank"
                    className={styles["file-link"]}
                  >
                    {nombreCompleto}
                  </a>
                </div>
              );
            })
          )}
        </div>
        {/* ============================
            BOTONES PRINCIPALES
        ============================ */}
        {!mostrarDropzone && (
          <div className={styles["botonera"]}>
            <button
              className={styles["btn-guardar"]}
              onClick={() => setMostrarDropzone(true)}
            >
              Agregar archivos
            </button>

            <button
              className={`${styles["btn-editar"]} ${
                (archivosExistentes || []).length === 0 ? styles["disabled"] : ""
              }`}
              disabled={(archivosExistentes || []).length === 0}
            >
              Editar
            </button>

            <button
              className={styles["btn-cancelar"]}
              onClick={onClose}
            >
              Cerrar
            </button>
          </div>
        )}

        {/* ============================
            DROPZONE
        ============================ */}
        {mostrarDropzone && (
          <>
            <div
              {...getRootProps()}
              className={styles["dropzone"]}
              style={{
                background: isDragActive ? "#3a3a3a" : "#2a2a2a"
              }}
            >
              <input {...getInputProps()} />

              {archivoAReemplazar ? (
                <p>
                  Arrastra el archivo que reemplazará a{" "}
                  <b>{archivoAReemplazar.Nombre_archivo}</b>
                </p>
              ) : (
                <p>Arrastra archivos aquí o haz clic para seleccionar</p>
              )}
            </div>

            {/* LISTA DE NUEVOS ARCHIVOS */}
            {nuevos.length > 0 && (
              <>
                <h4 className={styles["section-title"]}>Archivos nuevos</h4>

                {nuevos.map((file, i) => (
                  <div key={i} className={styles["file-item"]}>
                    {file.name}
                    <button
                      className={styles["btn-cancelar"]}
                      onClick={() =>
                        setNuevos(prev => prev.filter((_, idx) => idx !== i))
                      }
                    >
                      Quitar
                    </button>
                  </div>
                ))}
              </>
            )}

            {/* BOTONES CUANDO SE ESTÁ SUBIENDO */}
            <div className={styles["botonera"]}>
              <button
                className={styles["btn-guardar"]}
                onClick={handleGuardar}
              >
                Subir archivos
              </button>

              <button
                className={styles["btn-cancelar"]}
                onClick={onClose}
              >
                Cancelar
              </button>
            </div>
          </>
        )}

      </div>
    </div>
  );
}

export default ModalArchivo;
